<template>
	<div
		v-show="isOpen"
		class="advanced-options expanded"
	>
		<div class="adv-option-groups">
			<div class="row justify-content-between no-gutters">
				<div class="col-9 col-xxl-8">
					<div class="row no-gutters">
						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									@click="formData.schematic = 'swingtank'"
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'swingtank',
									}"
									data-value="swingtank"
								>
									<figure class="filter-blend">
										<object
											tabindex="-1"
											type="image/svg+xml"
											data="/static/build/gfx/schematic-swingtank.svg"
											class="schematic">
										</object>
									</figure>

									<div class="btn">
										<span>Swing Tank</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									@click="formData.schematic = 'paralleltank'"
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'paralleltank',
									}"
									data-value="paralleltank"
								>
									<figure class="filter-blend">
										<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/schematic-paralleltank.svg" class="schematic"/>
									</figure>

									<div class="btn">
										<span>Parallel Loop Tank</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>

									<p class="locked">
										<i class="symbol help left">
											<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/svg/symbol-disabled.svg"/>
										</i>

										Not available in California<br> Specification Mode
									</p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2">
							<div class="schematic-option">
								<a
									@click="formData.schematic = 'singlepass_norecirc'"
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'singlepass_norecirc',
									}"
									data-value="singlepass_norecirc"
								>
									<figure class="filter-blend">
										<object tabindex="-1" type="image/svg+xml" data="/static/build/gfx/schematic-primary.svg" class="schematic"/>
									</figure>

									<div class="btn">
										<span>Primary - No Recirculation</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2 mt-3">
							<div class="schematic-option">
								<a
									@click="formData.schematic = 'sprtp'"
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'sprtp',
									}"
									data-value="sprtp"
								>
									<figure class="filter-blend">
										<object
											tabindex="-1"
											type="image/svg+xml"
											data="/static/build/gfx/schematic-singlepassRTP.svg"
											class="schematic">
										</object>
									</figure>

									<div class="btn">
										<span>Single Pass Return to Primary</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
								</div>
							</div>
						</div>

						<div class="col-4 px-2 mt-3">
							<div class="schematic-option">
								<a
									@click="formData.schematic = 'mprtp'"
									:class="{
										'js-schematic-btn': true,
										toggled: formData.schematic === 'mprtp',
									}"
									data-value="mprtp"
								>
									<figure class="filter-blend">
										<object
											tabindex="-1"
											type="image/svg+xml"
											data="/static/build/gfx/schematic-multipassRTP.svg"
											class="schematic">
										</object>
									</figure>

									<div class="btn">
										<span>Multi Pass Return to Primary</span>
									</div>
								</a>

								<div class="suffix-wrap pl-4">
									<p class="desc"></p>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="col-3 pl-3 pl-xxl-0">
					<p>A temperature maintenance system provides hot water to the taps in a timely manner.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import formData from '@/components/Sizer/form-data-store'

export default {
	name: 'ElectricHeatingOpts',

	props: {
		isOpen: {
			type: Boolean,
			default: false,
		},
	},

	data: () => ({
		formData,
	}),
}
</script>
